import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getClasses = ({ disabled, dsf_level, dsf_size, dsf_square }) => {
  const classes = [
    "flex-auto",
    "flex",
    "border",
    "rounded",
    "items-center",
    "justify-center",
    "outline-none",
    "relative"
  ];
  if (!dsf_square) {
    classes.push("gap-8");
  }
  switch (dsf_size) {
    case "large":
      classes.push("h-48 min-w-48");
      if (dsf_square) {
        classes.push("w-48");
      }
      break;
    case "small":
      classes.push("h-32 min-w-32");
      if (dsf_square) {
        classes.push("w-32");
      }
      break;
    default:
      classes.push("h-40 min-w-40");
      if (dsf_square) {
        classes.push("w-40");
      }
  }
  switch (dsf_size) {
    case "large":
      classes.push("px-16");
      break;
    case "small":
      classes.push("px-8");
      break;
    default:
      classes.push("px-12");
  }
  switch (dsf_level) {
    case "secondary":
      if (disabled) {
        classes.push("bg-neutral-50", "border-neutral-100");
      } else {
        classes.push(
          "bg-neutral-0",
          "border-neutral-200",
          "hover:bg-neutral-50",
          "hover:border-neutral-200",
          "focus:bg-neutral-0",
          "focus:border-neutral-200",
          "focus-visible:shadow-focus-neutral-md",
          "active:bg-neutral-200",
          "active:border-neutral-200"
        );
      }
      break;
    case "destructive":
      if (disabled) {
        classes.push("bg-neutral-100", "border-neutral-100");
      } else {
        classes.push(
          "bg-error-300",
          "border-error-300",
          "hover:bg-error-400",
          "hover:border-error-400",
          "focus:bg-error-300",
          "focus-visible:shadow-focus-danger-md",
          "active:bg-error-500",
          "active:border-error-500"
        );
      }
      break;
    default:
      if (disabled) {
        classes.push("bg-neutral-100", "border-neutral-100");
      } else {
        classes.push(
          "bg-primary-300",
          "border-primary-300",
          "hover:bg-primary-400",
          "hover:border-primary-400",
          "focus:bg-primary-300",
          "focus:border-primary-300",
          "focus-visible:shadow-focus-primary-md",
          "active:bg-primary-500",
          "active:border-primary-500"
        );
      }
  }
  return concatClasses(classes);
};
const textColorMap = {
  primary: "text-neutral-0",
  secondary: "text-neutral-700",
  destructive: "text-neutral-0"
};
const activeTextColorMap = {
  primary: "active:text-neutral-0",
  secondary: "active:text-neutral-700",
  destructive: "active:text-neutral-0"
};
const getButtonTextClasses = ({ disabled, dsf_level, dsf_size }) => {
  const classes = ["flex", "font-sans"];
  classes.push(dsf_size === "small" ? "dsf-text-xs" : "dsf-text-s");
  if (disabled) {
    classes.push("text-neutral-400");
  } else {
    classes.push(textColorMap[dsf_level]);
    classes.push(activeTextColorMap[dsf_level]);
  }
  return concatClasses(classes);
};
export {
  getButtonTextClasses,
  getClasses
};
